module.exports = __webpack_public_path__ + "static/media/UC Compound Cam 01.78e12ff8.webp";